import appPopup from './inc/appPopup';
import pizzaOfTheWeek from './inc/pizzaOfTheWeek'; // popup
import quantityInput from './inc/quantityInput';
import promocode from './inc/promocode';
import checkout from './inc/checkout';
import announce from './inc/announce';
import pizzaOfTheWeekAction from './inc/pizzaOfTheWeekAction';
import scrolledBody from './inc/scrolledBody';
import pizzaOfTheWeekMenu from './inc/pizzaOfTheWeekMenu';
import accordions from './inc/accordions';
import aprilFools from './inc/aprilFools';
import profilePage from './inc/profilePage';
import survey from './inc/survey';

window.onload = function(){
    //appPopup();
    pizzaOfTheWeek();
    quantityInput();
    promocode();
    checkout();
    announce();
    pizzaOfTheWeekAction();
    scrolledBody();
    pizzaOfTheWeekMenu();
    
    accordions();

    profilePage();
    aprilFools();
    survey();
}